import {
  ComponentCSVIndex,
  ComponentIndex,
  PdfChartItem,
  PdfTableItem,
} from '../../types/redux/pdfExports/FileExportsStore';
import {
  ADD_CHART_TO_PDF_EXPORT,
  ADD_COMPONENT_EXPORT_CSV,
  ADD_COMPONENT_TO_PDF_EXPORT,
  ADD_TABLE_TO_PDF_EXPORT,
  AddChartToPdfExportAction,
  AddComponentExportCSVAction,
  AddComponentToPdfExportAction,
  AddTableToPdfExportAction,
  CLEAR_CSV_EXPORT,
  CLEAR_PDF_EXPORT,
  ClearCSVExportAction,
  ClearPdfExportAction,
  SET_PDF_ANALYSIS_DATE,
  SetPdfAnalysisDateAction,
  CLEAR_PDF_ANALYSIS_DATE,
  ClearPdfAnalysisDateAction,
  REMOVE_COMPONENT_FROM_PDF_EXPORT,
  REMOVE_COMPONENT_FROM_CSV_EXPORT,
  RemoveComponentFromPdfExportAction,
  RemoveComponentFromCsvExportAction,
} from '../../types/redux/pdfExports/exportTypes';

export function addTableToPdfExport<T extends object>(
  tableItem: PdfTableItem<T>,
): AddTableToPdfExportAction<T> {
  return {
    type: ADD_TABLE_TO_PDF_EXPORT,
    payload: tableItem,
  };
}

export function addChartToPdfExport(
  chart: PdfChartItem,
): AddChartToPdfExportAction {
  return {
    type: ADD_CHART_TO_PDF_EXPORT,
    payload: chart,
  };
}

export function clearPdfExports(): ClearPdfExportAction {
  return {
    type: CLEAR_PDF_EXPORT,
  };
}

export function addComponentToPdfExport(
  index: ComponentIndex,
): AddComponentToPdfExportAction {
  return {
    type: ADD_COMPONENT_TO_PDF_EXPORT,
    payload: index,
  };
}

export function addComponentExportCSV(
  component: ComponentCSVIndex,
): AddComponentExportCSVAction {
  return {
    type: ADD_COMPONENT_EXPORT_CSV,
    payload: component,
  };
}

export function clearCSVExports(): ClearCSVExportAction {
  return {
    type: CLEAR_CSV_EXPORT,
  };
}

export function setPdfAnalysisDate(
  analysisDate: string,
): SetPdfAnalysisDateAction {
  return {
    type: SET_PDF_ANALYSIS_DATE,
    payload: analysisDate,
  };
}

export function clearPdfAnalysisDate(): ClearPdfAnalysisDateAction {
  return {
    type: CLEAR_PDF_ANALYSIS_DATE,
  };
}

export function removeComponentFromPdfExport(
  identifier: string,
): RemoveComponentFromPdfExportAction {
  return {
    type: REMOVE_COMPONENT_FROM_PDF_EXPORT,
    payload: identifier,
  };
}

export function removeComponentFromCsvExport(
  fileName: string,
): RemoveComponentFromCsvExportAction {
  return {
    type: REMOVE_COMPONENT_FROM_CSV_EXPORT,
    payload: fileName,
  };
}
